import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'empName',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    },
    {
      field: 'dayRange',
      type: 'input',
      label: '时间范围',
      placeholder: '请输入时间范围（天）',
      rules: [
        {
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            if (!value) {
              callback()
              return
            }
            if (!/^\d+$/.test(value) || parseInt(value) <= 0) {
              callback(new Error('请输入正整数'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }
      ]
    },
    {
      field: 'maxWatchDays',
      type: 'input',
      label: '最大观看天数',
      placeholder: '请输入最大观看天数阈值',
      rules: [
        {
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            if (!value) {
              callback()
              return
            }
            if (!/^\d+$/.test(value) || parseInt(value) <= 0) {
              callback(new Error('请输入正整数'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }
      ]
    }
  ]
}
